import styled from 'styled-components';
import {
  Typography,
  Column as DefaultColumn,
  Checkbox as DefaultCheckbox,
} from '~components';

export const Column = styled(DefaultColumn)`
  margin-top: ${({ theme }) => theme.spacing.km10};

  & > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km8};
  }
`;

export const CheckboxLabel = styled(Typography).attrs({ as: 'span' })`
  font-size: ${({ theme }) => theme.font.size.m4};
  color: ${({ theme }) => theme.color.text.neutral.default};
  margin-right: ${({ theme }) => theme.spacing.km4};
  letter-spacing: -0.03em;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-right: ${({ theme }) => theme.spacing.km0};
  }
`;

export const Checkbox = styled(DefaultCheckbox)``;
